import React from "react";

export function Card({
  variant = "default", interactive = false, padding = "md",
  children, style = {}, ...rest
}) {
  const [hover, setHover] = React.useState(false);
  const pads = { none: 0, sm: "var(--space-4)", md: "var(--space-5)", lg: "var(--space-6)" };
  const skins = {
    default: {
      background: "var(--surface-card)", border: "1px solid var(--border-default)",
      boxShadow: "var(--shadow-soft)", color: "var(--text-body)",
    },
    raised: {
      background: "var(--surface-raised)", border: "1px solid var(--border-default)",
      boxShadow: "var(--shadow-deep)", color: "var(--text-body)",
    },
    featured: {
      background: "var(--surface-card)", border: "1px solid transparent",
      boxShadow: "0 0 0 2px var(--hive), var(--shadow-medium)", color: "var(--text-body)",
    },
    inverse: {
      background: "var(--surface-inverse-alt)", border: "1px solid var(--border-inverse)",
      boxShadow: "none", color: "var(--text-inverse)",
    },
    trust: {
      background: "var(--surface-trust)", border: "1px solid #C9DBE1",
      boxShadow: "none", color: "var(--text-body)",
    },
  };
  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        borderRadius: "var(--radius-md)", padding: pads[padding],
        transition: "transform var(--duration-base) var(--ease-out), box-shadow var(--duration-base) var(--ease-out), border-color var(--duration-base) var(--ease-out)",
        ...skins[variant],
        ...(interactive && hover && variant !== "inverse"
          ? { transform: "translateY(-2px)", boxShadow: "var(--shadow-medium)", borderColor: "var(--hive)" }
          : null),
        ...(interactive ? { cursor: "pointer" } : null),
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
}
